const CHARS = 'AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz0123456789';

export function rngi(min, max) {
    let ret = 0;
    const range = max - min;

    const bitsNeeded = Math.ceil(Math.log2(range));
    if(bitsNeeded > 53)
        return -1;

    const bytesNeeded = Math.ceil(bitsNeeded / 8),
        mask = Math.pow(2, bitsNeeded) - 1;

    const bytes = new Uint8Array(bytesNeeded);
    crypto.getRandomValues(bytes);

    let p = (bytesNeeded - 1) * 8;
    for(let i = 0; i < bytesNeeded; ++i) {
        ret += bytes[i] * Math.pow(2, p);
        p -= 8;
    }

    ret &= mask;

    if(ret >= range)
        return rngi(min, max);

    return min + ret;
};

export function rngs(length) {
    let str = '';
    for(let i = 0; i < length; ++i)
        str += CHARS[rngi(0, CHARS.length)];
    return str;
};
